import Rates from './Info/Views/RatesView'
import Miscellaneous from './Info/Views/Miscellaneous'

export const other = [
  {
    id: "Rates",
    content: <Rates />,
    title: "Rates"
  },
  {
    id: "Miscellaneous",
    content: <Miscellaneous />,
    title: "Miscellaneous",
  }
]
